import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import {makeStyles, useTheme, ThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import { Tabs, Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Tab from '@material-ui/core/Tab';
import {} from '@material-ui/icons';
import Box from '@material-ui/core/Box';
import { green, purple } from '@material-ui/core/colors';
import { useForm } from 'react-final-form-hooks'
import Tomo from './tomo'
import Trc21 from './trc21'
import Trc721 from './trc721'
import Table from "../../components/table/fixedHeader";
import { CSVLink } from "react-csv";
import moment from 'moment';
import useLoading from 'Frontend/components/loading/hook'
import LoadingUi from 'Frontend/components/loading/ui'
import httpp from "../../service/http";
import configg from '../../../config'
import Trc21ABI from "./Trc21ABI";
import Web3Services, {Web3, web3} from 'Backend/Web3'
import ABI from "./ABI";

let http
function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: '100%',
        padding: '0 20px'
    },
    roottomo: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: 200,
        },
    },
    margin: {
        margin: theme.spacing(1),
    },
}));

const theme = createMuiTheme({
    palette: {
        primary: green,
    },
});
export default function FullWidthTabs({userAuth}) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [loading, withLoading] = useLoading()
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const columns = [
        {
            maxWidth: 170,
            label: 'Hash',
            id: 'hash',
            hash: true
        },
        {
            maxWidth: 170,
            label: 'Type',
            id: 'type',
        },
        {
            maxWidth: 100,
            label: 'Amount',
            id: 'amount',
        },
        {
            maxWidth: 270,
            label: 'Link',
            id: 'link',
            link: true
        },
        {
            maxWidth: 70,
            label: 'retrieve',
            id: 'code',
            retrieve: true,
        },
        {
            maxWidth: 170,
            label: 'Created At',
            id: 'createdAt',
        },
        {
            maxWidth: 170,
            label: 'Start Time',
            id: 'fromDate',
        },

        {
            maxWidth: 170,
            label: 'End Time',
            id: 'toDate',
        },{
            minWidth: 100,
            label: 'Status',
            id: 'status',
        },{
            minWidth: 150,
            label: 'Password',
            id: 'password',
        },]
    const [tableRows, setTableRows] = React.useState([]);
    const [totalItems, setTotalItems] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [page, setPage] = React.useState(0);
    const [config, setConfig] = React.useState({});
    const handleChangeIndex = (index) => {
        setValue(index);
    };
    const setPageM = (value) => {
        setPage(value)
        // console.log(111, page)
        fetchData({page: value, rowsPerPage})
    }
    const setRowsPerPageM = (value) => {
        setRowsPerPage(value)
        setPage(0)
        fetchData({page, rowsPerPage: value})
    }
    const handleLoadData = (rs) => {

        setTableRows(rs.data.map(r => {
            r.amount = r.metaData.amount
            r.isPassword *= 1
            r.createdAt = moment(r.createdAt).format('YYYY-MM-DD HH:mm:ss')
            r.fromDate = moment.unix(r.metaData.fromDate).format('YYYY-MM-DD HH:mm:ss')
            r.toDate = moment.unix(r.metaData.toDate).format('YYYY-MM-DD HH:mm:ss')
            r.link = r.metaData.link
            r.password = r.metaData.password
            if(r.status === 'ready') {
                if(moment().isAfter(moment(r.toDate))) {
                    r.status = 'Expired'
                }
            }
            return r
        }))
        setTotalItems(rs.totalItems)
    };
    const handleConfig = async () => {

        const netid = await Web3Services.getNetwork()

        setConfig(configg[netid])
        http = httpp(configg[netid])
        fetchData({page, rowsPerPage})
    };
    const fetchData = ({page, rowsPerPage}) => {
        const type = value == 0 ? 'tomo' : (value == 1 ? 'trc21' : 'trc721')
        // console.log(page)
        userAuth.address && withLoading(() => http.get({ path: 'receive-link/' + userAuth.address,
            params: {type,
                limit: rowsPerPage,
                page: page + 1,
            } }).then(rs => {

            rs.data = rs.data.map(r => {
                r.amount = r.metaData.amount || r.metaData.tokenIds
                r.fromDate = r.metaData.fromDate
                r.toDate = r.metaData.toDate

                return r
            })
            handleLoadData(rs)
        }))
    }

    const retrieve = (row) => {

        const contractAddress = config.contractReceiveLink
        const contract = web3.eth.contract(ABI).at(contractAddress);
        const func = row.type === 'tomo' ? 'requestSendTomo' : (row.type === 'trc21' ? 'requestSendTRC21' : 'requestSendTRC721')
        const dataTx = contract[func].getData(row.code);
        const rawTx = {
            to: contractAddress,
            data:dataTx,
            gasPrice: 300000000,
            gasLimit: 1000000000,
        }
        web3.eth.sendTransaction(rawTx, async (err, res) => {
            if (!err) {
                await withLoading(() => setTimeout(() => fetchData({page, rowsPerPage}), 3000))
            } else {
                console.log(err)
            }
        })
    }

    React.useEffect( () => {
// console.log(userAuth)

        handleConfig()
    }, [])
    const csvDataAll = [
        { label: "Address", key: "userAddress" },
        { label: "Code", key: "code" },
        { label: "Hash", key: "hash" },
        { label: "Count Request", key: "countRequest" },
        { label: "Is Password", key: "isPassword" },
        { label: "Status", key: "status" },
        { label: "Type", key: "type" },
        { label: "Amount", key: "amount" },
        { label: "fromDate", key: "fromDate" },
        { label: "toDate", key: "toDate" },
        { label: "link", key: "link" },
        { label: "password", key: "password" },
    ];
    return (
        <div className={classes.root}>
            {loading && <LoadingUi/>}
            <div style={{
                paddingTop: 20,
                borderBottom: '1px solid #9FA7AA',
                marginBottom: 10
            }}>
                {
                    userAuth && userAuth.address &&
                        <h5 style={{height: 30}}>
                            Address: <a target='_blank' href={config.exploreUrl + 'address/' + userAuth.address}>{userAuth.address}</a>

                            <CSVLink
                                filename={moment().format("YYYY-MM-DD_HH-mm-ss") + "_receive_link.csv"}
                                headers={csvDataAll}
                                data={tableRows}
                                style={{float: 'right'}}
                            >
                                <Button variant="contained" className="btn" style={{background: '#898BC2'}}>Export CSV</Button>

                            </CSVLink>
                        </h5>
                }
            </div>
            <div className="addressEth">
                <Table retrieve={retrieve} config={config} columns={columns}  rows={tableRows} totalItems={totalItems} setRowsPerPageM={setRowsPerPageM} setPageM={setPageM} pageM={page}></Table>
                {/*<SimpleTable columns={tableCol} rows={tableRows}/>*/}
            </div>

            <h1 style={{marginTop: 20,
                fontWeight: 'bold',
                fontSize: 18

            }}>Create Link</h1>
            <div style={{
                boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
            }}>
                <AppBar position="static" color="default" style={{width: '40%', padding: 0}}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                    >
                        <Tab label="TOMO" {...a11yProps(0)} />
                        <Tab label="TRC21" {...a11yProps(1)} />
                        <Tab label="TRC721" {...a11yProps(2)} />
                    </Tabs>
                </AppBar>
                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                >
                    <TabPanel value={value} index={0} dir={theme.direction}>
                        <Tomo withLoading={withLoading} userAuth={userAuth} setTableRows={handleLoadData}
                              setPageM={setPageM}
                              config={config}
                              rowsPerPage={rowsPerPage}/>

                    </TabPanel>
                    <TabPanel value={value} index={1} dir={theme.direction}>
                        <Trc21 config={config}
                                withLoading={withLoading} userAuth={userAuth} setTableRows={handleLoadData} setPageM={setPageM}/>
                    </TabPanel>
                    <TabPanel value={value} index={2} dir={theme.direction}>
                        <Trc721 config={config} withLoading={withLoading} userAuth={userAuth} setTableRows={handleLoadData} setPageM={setPageM}/>
                    </TabPanel>
                </SwipeableViews>
            </div>
        </div>
    );
}
